import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import {type confirmAccountLinkUserQueryType} from "./__graphql-types__/index.ts";

export const CONFIRM_ACCOUNT_LINK_USER_QUERY: GqlOperation<
    confirmAccountLinkUserQueryType["response"],
    confirmAccountLinkUserQueryType["variables"]
> = gqlOp(gql`
    query confirmAccountLinkUserQuery {
        user {
            id
            cleverId
            age
            nickname
            userDistrictInfos {
                id
            }
        }
    }
`);
